<script setup lang="ts">
import { ActionMenuExposed } from './ActionMenu.ts';
import { FlexDirection, Spacing } from 'omind-design-system/tokens';
import { ref } from 'vue';

withDefaults(
  defineProps<{
    visibleBackdrop?: boolean;
  }>(),
  {
    visibleBackdrop: false,
  },
);

const openedAction = ref(false);

function openAction() {
  openedAction.value = true;
}

function closeAction() {
  openedAction.value = false;
}

defineExpose<ActionMenuExposed>({
  openAction,
  closeAction,
});
</script>

<template>
  <div class="actions-dropdown-container" :class="{ show: openedAction }">
    <div
      class="actions-dropdown-backdrop"
      :class="{ visible: visibleBackdrop }"
      @click.stop="closeAction()"
    ></div>
    <div class="actions-dropdown">
      <odsBox :direction="FlexDirection.Column" :padding="Spacing.None">
        <slot />
      </odsBox>
    </div>
  </div>
</template>

<style lang="scss">
.actions-dropdown-container {
  .actions-dropdown-backdrop {
    position: fixed;
    background: var(--color-purple-500);
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    z-index: 101;
    opacity: 0;
    pointer-events: none;
    transition: opacity 150ms ease-out;
  }

  .actions-dropdown {
    position: absolute;
    background: var(--color-neutral-10);
    border-radius: var(--border-radius-large);
    box-shadow:
      0px 0px 30px 0px rgba(66, 0, 255, 0.04),
      0px 10px 30px 0px rgba(88, 92, 98, 0.08);
    top: 150%;
    right: 0%;
    z-index: 102;
    opacity: 0;
    transform: translateX(15px);
    transition:
      opacity 150ms ease-out,
      transform 150ms ease-out;
    pointer-events: none;

    .ods-button {
      text-decoration: none !important;
      justify-content: start;
      width: 100%;
      padding-left: var(--spacing-standard);
      padding-right: var(--spacing-standard);
    }
  }

  &.show {
    .actions-dropdown-backdrop {
      pointer-events: auto;
      cursor: default;

      &.visible {
        opacity: 0.24;
      }
    }

    .actions-dropdown {
      opacity: 1;
      transform: translateX(0);
      pointer-events: auto;
    }
  }
}
</style>
